const contents = {
  header: 'Allogene Therapeutics',
  logoTooltip: {
    href: 'https://allogene.com/',
    copy: 'allogene.com'
  },
  hero: {
    background: 'video',
    logoPlacement: 'top',
    title: 'Breaking the CAR T Access Bottleneck for Patients with Cancer',
    copy: ''
  }
};

export default contents;
